v-col<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <div class="d-flex justify-end">
      <v-btn 
        color="brand onBrand--text"
        dark
        small
        style="margin-right:0.5em;border-radius:8px;margin-top:-7px"
        @click="videoDialog = true"
      >
      <v-icon left>mdi-youtube</v-icon>
      Watch Tutorial
      </v-btn>
      </div>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Apply Transport Facility</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" align="center" dense>
            <v-col cols="12" sm="4" md="3">
              <p>
                <b>Child</b>
                <v-icon small class="pb-2 pl-1" color="error">*</v-icon>
              </p>
              <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="child"
                :items="child_list"
                item-text="learner"
                item-value="id"
                label="Child"
                outlined
                persistent-hint
                hint="Please Select Child"
              />
            </v-col>

            <v-col cols="12" sm="4" md="3">
              <p>
                <b>Academic Year</b>
                <v-icon small class="pb-2 pl-1" color="error">*</v-icon>
              </p>
              <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="ay"
                :items="ay_list"
                item-text="ay"
                item-value="id"
                label="Academic Year"
                outlined
                persistent-hint
                hint="Please Select Academic Year"
              />
            </v-col>

            <v-col
              cols="auto"
              class="mt-2"
              v-if="ay && child"
            >
              <v-btn color="warning" @click="fetchData()">
                Fetch
              </v-btn>
            </v-col>

            <v-col
              cols="auto"
              class="mt-2"
              v-if="ay && child"
            >
              <v-btn color="warning" @click="fetchBusTracking()">
                Bus Tracking
              </v-btn>
            </v-col>
          </v-row>
        <v-row dense justify="center">
          <v-col cols="12" sm="10" md="10">
            <v-alert type="warning" text prominent>
              <!-- <div class="note-list"> -->
              <strong>Note: </strong>
              <ul>
                <li>Select Appropriate Route</li>
                <li>
                  Apply for payment method (Select installment for selected
                  route)
                </li>
                <li>
                  Once applied, wait for approval from school/transportation.
                  (Check Approval status column from Payment-Route-Installment
                  Details)
                </li>
                <li>
                  After approval, you can pay the transportation fee for the
                  selected route & installment.
                </li>
              </ul>
              <!-- </div> -->
            </v-alert>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="box" v-if="show_child_details_card">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Child Details</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row class="custom-row" no-gutters>
          <v-col cols="12" sm="3" class="cell">
            <p class="label">PRN</p>
            <strong>{{ child_details.registration_number }}</strong>
          </v-col>
          <v-col cols="12" sm="4" class="cell">
            <p class="label">Student Name</p>
            <strong>{{ child_details.learner }}</strong>
          </v-col>

          <v-col cols="12" sm="1" class="cell">
            <p class="label">Standard</p>
            <strong>{{ child_details.standard }}</strong>
          </v-col>

          <v-col cols="12" sm="1" class="cell">
            <p class="label">Pick Up Time</p>
            <strong>{{ child_details.pickup_time || '-' }}</strong>
          </v-col>

          <v-col cols="12" sm="1" class="cell">
            <p class="label">Drop Time</p>
            <strong>{{ child_details.drop_time || '-' }}</strong>
          </v-col>

          <v-col cols="12" sm="1" class="cell">
            <p class="label">Division</p>
            <strong>{{ child_details.learnerDivision }}</strong>
          </v-col>

          <v-col cols="12" sm="1" class="cell">
            <p class="label">Roll No</p>
            <strong>{{ child_details.roll_no }}</strong>
          </v-col>
      </v-row>
      </v-card>
      <v-row justify="center" dense v-if="show_child_details_card">
        <v-col cols="12" sm="1" md="1"></v-col>
        <v-col
          col="12"
          sm="4"
          md="4"
          v-if="learner_transport_fees_list.length < 1"
        >
          <v-btn color="warning" @click="applyTransport()"
            >Select Appropriate Route</v-btn
          >
        </v-col>
      </v-row>
      <v-card class="box" v-if="learner_transport_fees_list.length > 0">
        <v-row justify="center" dense>
          <v-col cols="12" sm="12">
            <!-- <v-card class="box" > -->
            <v-simple-table dense class="elevation-1">
              <template>
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Route</th>
                    <th>Route Stop</th>
                    <!-- <th>Distance Slab In KM</th> -->
                    <th>Fees In Rs.</th>
                    <th>Apply For Paynent Method</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(item, i) in learner_transport_fees_list" :key="i">
                    <td>{{ i + 1 }}</td>
                    <td>{{ item.route }}</td>
                    <td>{{ item.routestop }}</td>
                    <!-- <td>{{ item.distanceslab }}</td> -->
                    <td>{{ item.totalfees }}</td>
                    <td>
                      <v-btn
                        color="warning"
                        @click="applyPaymentMethod(item.id)"
                        >Apply</v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card>

      <!-- <v-row
        justify="center"
        dense
        v-if="learner_transport_fees_list.length > 0"
      >
        <v-col cols="12" sm="1" md="1"></v-col>

        <v-col col="12" sm="4" md="4">
          <v-btn color="warning" @click="applyPaymentMethod()"
            >Apply For Paynent Method</v-btn
          >
        </v-col>
      </v-row> -->
      <br />

      <v-dialog v-model="show_apply_transport_card" fullscreen>
        <v-card>
          <v-toolbar class="toolbar no-display" flat dense>
            <v-btn icon dark @click="show_apply_transport_card = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <strong> Apply Transport Facility </strong>
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <!-- <v-row justify="center" dense> -->
          <v-card class="box" v-if="show_child_details_card">
            <v-row justify="center" dense>
              <v-col cols="12" sm="4" md="4">
                <p><b>PRN</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.registration_number"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <p><b>Student Name</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.learner"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <p><b>Standard</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.standard"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <p><b>Pick Up Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.pickup_time"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <p><b>Drop Time</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.drop_time"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <p><b>Academic Year</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.academicYear"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card>
          <!-- </v-row> -->

          <!-- <v-row justify="center" dense> -->
          <v-card class="box" v-if="show_child_details_card">
            <v-row justify="center" dense>
              <v-col cols="12" sm="4" md="4">
                <p><b>Contact No</b></p>
                <v-text-field
                  outlined
                  dense
                  type="text"
                  v-model="child_details.contact"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <p><b>Resedential Address</b></p>
                <v-text-field
                  outlined
                  v-model="child_details.resedential_address"
                  label="Enter Address"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="4" md="4">
                <p><v-icon color="error">*</v-icon><b>Route Stop</b></p>
                <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="route_stop"
                  @change="getRoutes()"
                  :items="route_stops"
                  item-text="name"
                  item-value="id"
                  label="Route Stop"
                  outlined
                  persistent-hint
                  hint="Please Select Route Stop"
                />
              </v-col>
              <!-- <v-col cols="12" sm="4"> </v-col> -->
            </v-row>

            <v-row justify="center" dense v-if="route_details_list.length > 0">
              <v-col cols="12" sm="12" md="12">
                <!-- <v-card class="box" > -->
                <v-simple-table dense class="elevation-1">
                  <template>
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Route</th>
                        <th>Distance Slab In KM</th>
                        <th>Fees In Rs.</th>
                        <th>Select Route</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr v-for="(item, i) in route_details_list" :key="i">
                        <td>{{ i + 1 }}</td>
                        <td>{{ item.route }}</td>
                        <td>{{ item.distance }}</td>
                        <td>{{ item.fees }}</td>
                        <td>
                          <input
                            type="radio"
                            name="selected_route"
                            class="radiospace"
                            v-model="selected_route"
                            v-bind:value="item.id"
                          />
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <v-row
                  justify="center"
                  class="pt-5"
                  dense
                  v-if="selected_route"
                >
                  <!-- <v-col col="12" sm="6" md="6"> -->
                  <v-btn small color="warning" @click="SaveApplyTransport()"
                    >Save</v-btn
                  >
                  <!-- </v-col> -->
                </v-row>

                <!-- </v-card> -->
              </v-col>
            </v-row>
          </v-card>
          <!-- </v-row> -->
        </v-card>
      </v-dialog>

      <v-card class="box" v-if="apply_payment_card">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Select Payment Method</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="4" md="4">
            <p><b>PRN</b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="child_details.registration_number"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <p><b>Student Name</b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="child_details.learner"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <p><b>Academic Year </b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="child_details.academicYear"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <p><b>Route Stop</b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="fees_details.routestop"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <p><b>Route</b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="fees_details.route"
              readonly
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="4" md="4">
            <p><b>Diatance Slab</b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="fees_details.distanceslab"
              readonly
            ></v-text-field>
          </v-col> -->
        </v-row>
        <!-- <v-card class="box"> -->
        <v-row justify="center" dense>
          <v-col cols="12" sm="4" md="4">
            <p><b>Total Fees Applicable In Rs.</b></p>
            <v-text-field
              outlined
              dense
              type="text"
              v-model="fees_details.totalfees"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="center" dense v-if="!this.tranport_fee_sync">
          <span
            v-for="(inst, index) in all_transport_installments"
            :key="index"
          >
            <input
              type="radio"
              class="radiospace"
              v-model="transport_installment"
              v-bind:value="inst"
              @change="setName(inst.id)"
            />
            {{ inst.name }}
          </span>
        </v-row>
        <v-row v-else justify="center" dense>
           <v-btn small color="warning" @click="SaveTransportInstallmentNew()"
            >Apply Transport</v-btn
          >
        </v-row>
        <v-row justify="center" dense v-if="show_fees">
          <p><b>Installment Fees In Rs.</b></p>
          {{ fees_applicable }}
        </v-row>
        <v-row justify="center" dense v-if="show_fees">
          <v-btn small color="warning" @click="SaveTransportInstallment()"
            >Save</v-btn
          >
        </v-row>
      </v-card>
    <span v-if="tranport_fee_sync">
      <v-card
        class="box"
        v-if="transport_installments != '' && learner_transport_fees_list != ''"
      >
        <v-data-table
          :headers="headers"
          dense
          class="elevation-1"
          :items="transport_installments"
        >
          <template v-slot:top>
            <v-toolbar flat dense class="toolbar">
              <v-toolbar-title
                >Payment-Route-Installment Details</v-toolbar-title
              >
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.cancel_request`]="{ item }">
            <!-- {{item.raise_cancel_request}} -->
            <!-- {{item.is_transport_sync}} -->
            <!-- {{item.raise_cancel_request}} {{item.request_for_calcellation}} -->
            <span v-if="item.raise_cancel_request ==true && item.request_for_calcellation == false && item.is_transport_sync==true && item.iscancelled == false">
                <v-btn small color="warning" @click="requestTransportInstallmentCancel(item)"
                   >Request Cancel</v-btn
          >
            </span>
           <span v-else-if="item.raise_cancel_request ==false">
             Fees Paid...Cannot Cancel
            </span>
           <span v-else-if="item.iscancelled ==true">
             Already Cancelled
            </span>
              <span v-else-if="item.is_transport_sync ==false">
                   Fees Not Synced...Cannot Cancel
            </span>
              <span v-else-if="item.request_for_calcellation ==true">
                  Already Requested
            </span>
              <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
              <!-- Cannot Cancel -->
            </span>
          </template>
          <template v-slot:[`item.transportapprovalstatus`]="{ item }">
            <span v-if="item.is_transport_sync">
              <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
          <template v-slot:[`item.is_approved`]="{ item }">
            <span v-if="item.is_approved">
              <!-- <v-btn small :disabled="item.ispaid" color="warning" @click="pay()">Pay</v-btn> -->
              <!-- {{item.ispaid}} -->
              <span v-if="item.ispaid == true">
                <strong>Already Paid</strong>
              </span>
              <span v-else>
                <form
                  :action="url"
                  @submit="payment"
                  name="paytmform"
                  method="POST"
                >
                  <input type="hidden" :value="item.orgid" name="orgid" />
                  <input type="hidden" :value="item.tenantid" name="tenantid" />
                  <input type="hidden" :value="item.uid" name="uid" />
                  <input type="hidden" :value="item.learner_id" name="studid" />
                  <!-- <input type="hidden" :value="item.amount" name="fee_amount" /> -->
                  <input type="hidden" :value="item.to_pay" name="fee_amount" />
                  <input type="hidden" :value="item.ay" name="ay" />
                  <input type="hidden" :value="item.name" name="purpose" />
                  <input
                    type="hidden"
                    :value="item.learner_transport_fees_installment_id"
                    name="learner_transport_fees_installment_id"
                  />
                  <!-- //Code Changed By mayur -->
                  <!-- <input type="hidden" :value="item.id" name="json_pre_trans_data"/> //Code Changed By mayur -->
                  <input
                    type="hidden"
                    :value="item.learner_transport_fees_installment_id"
                    name="json_pre_trans_data"
                  />
                  <input type="hidden" :value="item.hash_val" name="hash_val" />
                  <v-btn small color="warning" type="submit" :loading="loader"
                    >Proceed</v-btn
                  >
                </form>
              </span>
            </span>
            <span v-else> -- </span>
          </template>
          <template v-slot:[`item.print`]="{ item }">
            <span v-for="item in item.receipt_no" :key="item">
              <v-tooltip top color="warning">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mt-1 mb-1"
                    rounded
                    outlined
                    small
                    color="warning"
                    v-bind="attrs"
                    v-on="on"
                    @click="print(item, item.ay)"
                  >
                    <v-icon color="warning">mdi-printer</v-icon
                    >{{ item }}</v-btn
                  >
                </template>
                <span> Print Fee Receipt!!! </span>
              </v-tooltip>
            </span>
            <!-- <span v-if="item.is_approved">
                            <span v-if="item.ispaid == true">
                                <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on" @click="print(item.receipt_no,item.ay)"> <v-icon color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                                </template>
                                <span>
                                    Print Fee Receipt!!!
                                </span>
                            </v-tooltip>
                            </span>
                            <span v-else>
                                --
                            </span>
                        </span>
                        <span v-else> -- </span> -->
          </template>
        </v-data-table>
      </v-card>
      </span>

       <span v-else>
      <v-card
        class="box"
        v-if="transport_installments != '' && learner_transport_fees_list != ''"
      >
        <v-data-table
          :headers="headers_2"
          dense
          class="elevation-1"
          :items="transport_installments"
        >
          <template v-slot:top>
            <v-toolbar flat dense class="toolbar">
              <v-toolbar-title
                >Payment-Route-Installment Details</v-toolbar-title
              >
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
          <template v-slot:[`item.transportapprovalstatus`]="{ item }">
            <span v-if="item.transportapprovalstatus == 'Approved'">
              <v-icon class="mr-2 v-icon-size" color="success"
                >mdi-check-circle-outline</v-icon
              >
            </span>
            <span v-else>
              <v-icon class="mr-2 v-icon-size" color="error"
                >mdi-close-circle-outline</v-icon
              >
            </span>
          </template>
          <template v-slot:[`item.is_approved`]="{ item }">
            <span v-if="item.is_approved">
              <span v-if="item.ispaid == true">
                <strong>Already Paid</strong>
              </span>
              <span v-else>
                <form
                  :action="url"
                  @submit="payment"
                  name="paytmform"
                  method="POST"
                >
                  <input type="hidden" :value="item.orgid" name="orgid" />
                  <input type="hidden" :value="item.tenantid" name="tenantid" />
                  <input type="hidden" :value="item.uid" name="uid" />
                  <input type="hidden" :value="item.learner_id" name="studid" />
                  <!-- <input type="hidden" :value="item.amount" name="fee_amount" /> -->
                  <input type="hidden" :value="item.to_pay" name="fee_amount" />
                  <input type="hidden" :value="item.ay" name="ay" />
                  <input type="hidden" :value="item.name" name="purpose" />
                  <input
                    type="hidden"
                    :value="item.learner_transport_fees_installment_id"
                    name="learner_transport_fees_installment_id"
                  />
                  <!-- //Code Changed By mayur -->
                  <!-- <input type="hidden" :value="item.id" name="json_pre_trans_data"/> //Code Changed By mayur -->
                  <input
                    type="hidden"
                    :value="item.learner_transport_fees_installment_id"
                    name="json_pre_trans_data"
                  />
                  <input type="hidden" :value="item.hash_val" name="hash_val" />
                  <v-btn small color="warning" type="submit" :loading="loader"
                    >Proceed</v-btn
                  >
                </form>
              </span>
            </span>
            <span v-else> -- </span>
          </template>
          <template v-slot:[`item.print`]="{ item }">
            <span v-for="item in item.receipt_no" :key="item">
              <v-tooltip top color="warning">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    class="mt-1 mb-1"
                    rounded
                    outlined
                    small
                    color="warning"
                    v-bind="attrs"
                    v-on="on"
                    @click="print(item, item.ay)"
                  >
                    <v-icon color="warning">mdi-printer</v-icon
                    >{{ item }}</v-btn
                  >
                </template>
                <span> Print Fee Receipt!!! </span>
              </v-tooltip>
            </span>
            <!-- <span v-if="item.is_approved">
                            <span v-if="item.ispaid == true">
                                <v-tooltip top color="warning">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mt-1 mb-1" rounded outlined small color="warning" v-bind="attrs" v-on="on" @click="print(item.receipt_no,item.ay)"> <v-icon color="warning">mdi-printer</v-icon>Print Receipt</v-btn>
                                </template>
                                <span>
                                    Print Fee Receipt!!!
                                </span>
                            </v-tooltip>
                            </span>
                            <span v-else>
                                --
                            </span>
                        </span>
                        <span v-else> -- </span> -->
          </template>
        </v-data-table>
      </v-card>
      </span>
    </v-container>
       <v-dialog v-model="videoDialog" max-width="1000px">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center grey lighten-4">
          <span style="color:black">Apply Transport Facility Tutorial</span>
          <v-btn icon @click="videoDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <v-responsive :aspect-ratio="16/9">
           <iframe
              v-if="videoDialog"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/FVYR0anwu9A?si=4nUliAfvcnQh5nPV"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data: () => ({
    tranport_fee_sync:false,
    loader: false,
    radios: null,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    videoDialog:false,
    overlay: false,
    title: "",
    description: "",
    headers: [
      { text: "Sr. No.", value: "srno", align:"center"},
      { text: "Installment", value: "name", align:"center" },
      // { text: "Amount", value: "amount" },
      { text: "Amount", value: "amount", align:"center" },
      // { text: "Amount", value: "sync_amount" },
     // { text: "Paid Till Now", value: "paid_till_now" },
      { text: "Route Stop", value: "route_stop", align:"center" },
      { text: "From Date", value: "from_date", align:"center" },
      { text: "To Date", value: "to_date", align:"center" },
      { text: "Due Date", value: "due_date", align:"center" },
      // { text: "Applied?", value: "is_applied" },
      { text: "Approval Status", value: "transportapprovalstatus", align:"center" },
    //  { text: "Payment", value: "is_approved" },
      //{ text: "Print Receipt", value: "print" },
      { text: "Request Cancellation", value: "cancel_request", align:"center" },
    ],
    headers_2: [
      { text: "Sr No", value: "srno" },
      { text: "Installment", value: "name" },
      { text: "Amount", value: "amount" },
     { text: "Paid Till Now", value: "paid_till_now" },
      { text: "Route Stop", value: "route_stop" },
      { text: "Remaining", value: "to_pay" },
      // { text: "From Date", value: "from_date" },
      // { text: "To Date", value: "to_date" },
      // { text: "Due Date", value: "due_date" },
      { text: "Approval Status", value: "transportapprovalstatus" },
     { text: "Payment", value: "is_approved" },
      { text: "Print Receipt", value: "print" },
      // { text: "Request Cancellation", value: "cancel_request" }, 
    ],
    ay_list: [],
    ay: "",
    child_list: [],
    child: "",
    child_details: {
      lid: "",
      registration_number: "",
      learner: "",
      standard: "",
      pickup_time: "",
      drop_time: "",
      academicYear: "",
      contact: "",
      resedential_address: "",
      learnerDivision: "",
      roll_no: "",
    },
    show_child_details_card: false,
    show_apply_transport_card: false,
    route_stops: [],
    route_stop: "",
    route_details_list: [],
    route_details: "",
    selected_route: null,
    learner_transport_fees_installment_details: [],
    learner_transport_fees_list: [],
    apply_payment_card: false,
    fees_details: {
      totalfees: "",
      paid_till_now: "",
      routestop: "",
      route: "",
      distanceslab: "",
    },
    transport_installments: [],
    all_transport_installments: [],
    transport_installment: "",
    selected_installment: "",
    fees_applicable: "",
    fees_applicable_origional: "",
    show_fees: false,
    learner_transport_fees_id: "",
    learner_transport_fees_amount_id: "",
    learner_transport_fees_installment_details: [],
    url: "",
  }),
  created() {
    this.url =
      process.env.VUE_APP_API_URL + "/paymentGatewayPayTM/paytm_transport";
  },
  methods: {
    fetchBusTracking() {
      this.$router.push({name: "bus-tracking-sbpps"})
    },
    resetData() {
      (this.transport_installments = []),
        (this.learner_transport_fees_installment_details = []),
        (this.fees_details = []),
        (this.selected_route = null),
        (this.show_child_details_card = false),
        (this.show_apply_transport_card = false),
        (this.fees_applicable_origional = ""),
        (this.show_fees = false),
        (this.apply_payment_card = false);
    },
    print(receipt_no, ay) {
      this.receipt_no = receipt_no;
      this.$session.set("receipt_no", JSON.stringify(receipt_no));
      this.$session.set("ay", JSON.stringify(ay));
      let routeData = this.$router.resolve({ name: "transport-receipt" });
      window.open(routeData.href, "_blank");
    },
    payment() {
      var formData = new FormData(paytmform);
      console.log("formData");
      console.log(formData);
      this.loader = false;
    },
    requestTransportInstallmentCancel(item) {
      if (!confirm("Are You Sure You Want To Cancel...?")) return;
      const data = {
        feesinstallmant_id: item.feesinstallmant_id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/requestTransportInstallmentCancel", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Request Sent...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.fetchData();
        });
    },
    SaveTransportInstallment() {
      if (!confirm("Are You Sure You Want To Apply...?")) return;
      const data = {
        academicYear: this.ay,
        learner: this.child_details.lid,
        learner_transport_fees_id: this.learner_transport_fees_id,
        transport_installment: this.transport_installment.id,
        fees_applicable: this.fees_applicable,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/SaveLearnerTransportInstallment", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.transport_installments = res.data.transport_installments;
            this.apply_payment_card = false;
            if(res.data.snackbar.includes("Already")){
              this.showSnackbar("red", res.data.snackbar);
            }else{
               this.showSnackbar("green", res.data.snackbar);
            }
          } else if (res.data.flag == "No") {
            this.apply_payment_card = false;
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    SaveTransportInstallmentNew() {
      if (!confirm("Are You Sure You Want To Apply...?")) return;
      const data = {
        academicYear: this.ay,
        learner: this.child_details.lid,
        learner_transport_fees_id: this.learner_transport_fees_id,
        //transport_installment: this.transport_installment.id,
        //fees_applicable: this.fees_applicable,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/SaveLearnerTransportInstallmentNew", data) 
        .then((res) => {
          if (res.data.flag == "YES") {
            this.transport_installments = res.data.transport_installments;
            this.apply_payment_card = false;
            this.showSnackbar("green", res.data.snackbar);
          } else if (res.data.flag == "No") {
            this.apply_payment_card = false;
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    setName(installment_name) {
      // alert("this.transport_installment::"+this.transport_installment.id)
      // this.fees_applicable = this.fees_applicable_origional;
      // if (installment_name != "Yearly") {
      //   this.fees_applicable = parseFloat(this.fees_applicable / 2);
      // } else {
      //   this.fees_applicable;
      // }
      // this.show_fees = true;
      // return this.fees_applicable;

      const data = {
        installment: installment_name,
        learner_transport_fees_amount_id: this.learner_transport_fees_amount_id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentAmount", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fees_applicable = res.data.final_amount;
            this.show_fees = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    applyPaymentMethod(learner_transport_fees_id) {
      (this.fees_applicable = ""),
        (this.fees_applicable_origional = ""),
        (this.transport_installment = []),
        (this.show_fees = false),
        (this.all_transport_installments = []); //chamged by mayur
      this.learner_transport_fees_amount_id = learner_transport_fees_id;
      const data = {
        learner_transport_fees_id: learner_transport_fees_id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/applyPaymentMethod", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fees_details.totalfees = res.data.totalfees;
            this.fees_details.paid_till_now = res.data.paid_till_now;
            this.fees_details.routestop = res.data.routestop;
            this.fees_details.route = res.data.route;
            this.fees_details.distanceslab = res.data.distanceslab;
            this.all_transport_installments = res.data.transport_installments;
            this.fees_applicable = res.data.totalfees;
            (this.fees_applicable_origional = res.data.totalfees),
              (this.learner_transport_fees_id =
                res.data.learner_transport_fees_id);
            // this.learner_transport_fees_installment_details =res.data.learner_transport_fees_installment_details;
            this.apply_payment_card = true;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    SaveApplyTransport() {
      if (!confirm("Are You Sure You Want To Apply...?")) return;
      const data = {
        academicYear: this.ay,
        selected_route: this.selected_route,
        learner: this.child_details.lid,
        contact: this.child_details.contact,
        address: this.child_details.resedential_address,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/SaveApplyTransport", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
            this.learner_transport_fees_list =
              res.data.learner_transport_fees_list;
            this.show_apply_transport_card = false;
            this.fetchData();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getRoutes() {
      const data = {
        route_stop: this.route_stop,
        ay: this.ay
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getRoutes", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.route_details_list = res.data.route_details_list;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          } 
          else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    applyTransport() {
      this.show_apply_transport_card = true;
      (this.selected_route = ""),
        (this.route_stop = ""),
        (this.route_details_list = []);
    },
    fetchData() {
      this.resetData();
      const data = {
        ay: this.ay,
        child: this.child,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getChildAcademicDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", "Saved Successfully..");
            this.child_details.registration_number =
              res.data.registration_number;
            this.child_details.learner = res.data.learner;
            this.child_details.lid = res.data.lid;
            this.child_details.standard = res.data.standard;
            this.child_details.pickup_time = res.data.pickup_time;
            this.child_details.learnerDivision = res.data.learnerDivision;
            this.child_details.roll_no = res.data.roll_no;
            this.child_details.drop_time = res.data.drop_time;
            this.child_details.academicYear = res.data.academicYear;
            this.child_details.contact = res.data.contact;
            this.child_details.resedential_address =
              res.data.resedential_address;
            this.route_stops = res.data.route_stops;
            this.learner_transport_fees_list =
              res.data.learner_transport_fees_list;
            this.fees_details.totalfees = res.data.totalfees;
            this.fees_details.paid_till_now = res.data.paid_till_now;
            this.fees_details.routestop = res.data.routestop;
            this.fees_details.route = res.data.route;
            this.fees_details.distanceslab = res.data.distanceslab;
            this.transport_installments = res.data.transport_installments;
            this.fees_applicable = res.data.totalfees;
            (this.fees_applicable_origional = res.data.totalfees),
              (this.learner_transport_fees_id =
                res.data.learner_transport_fees_id);
            this.learner_transport_fees_installment_details =
              res.data.learner_transport_fees_installment_details;
            this.show_child_details_card = true;
            this.tranport_fee_sync=res.data.tranport_fee_sync
          }else if(res.data.flag == "No"){
            this.showSnackbar("red", res.data.snackbar);
          } 
          else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    onLoad() {
      axios
        .post("ParentTransport/applyTransportFacility")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.child_list = res.data.learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
.custom-row {
  border: 1px solid #ccc;
  margin-top: 10px;
}

.cell {
  padding: 10px;
  text-align: center;
  border-right: 1px solid #ccc;
}

.cell:last-child {
  border-right: none;
}

.label {
  margin: 0;
  font-size: 13px;
  color: #555;
}
.radiospace {
  margin: 1rem !important;
  padding: 0%;
}
sub-row {
  border: 2px solid #424093;
  margin: 1rem;
  border-radius: 5px;
}

i {
  font-size: 20px !important;
}

.v-card__title {
  border: 1px solid #80808040;
  font-weight: bold;
  background-color: #424093;
  color: white;
  text-align: center;
  /* margin-top: 1.5rem; */
}
.card-border {
  border: 2px solid darkblue;
  border-radius: 10px;
  /* padding: 5px; */
  /* margin: 1rem !important; */
  width: auto;
}

.tx-bold {
  font-weight: bold;
  font-size: 14px;
  color: black;
}

i {
  font-size: 26px;
  cursor: pointer;
}

theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #424093 !important;
  color: white !important;
  margin-top: 2.35rem;
  border-radius: 20px;
}

/*.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined):hover {
    background-color: orange !important;
    color: black !important;
} */

@media only screen and (max-width: 600px) {
}

.imgs {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 150px;
  cursor: zoom-in;
}

.imgs-preview {
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: auto;
}

v-simple-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: auto;
  border: 1px solid #ddd;
}

th {
  color: white;
  font-weight: bold;
  text-align: center !important;
}

td,
th {
  padding: 6px;
  border: 1px solid #ccc;
  text-align: center;
}
@media all and (max-width: 900px) {
  .padding-bot {
    padding: 8px;
  }
}

@media all and (min-width: 1000px) {
  .padding-metting {
    padding-right: 22px;
  }
}
@media (min-width: 320px) and (max-width: 350px) {
  .padding-bot {
    font-size: 11.6px;
  }
}
@media (min-width: 1000px) and (max-width: 1050px) {
  .padding-bot {
    font-size: 9.6px;
  }
}
.slide {
  color: red;
  font-weight: bold;
  margin-left: 10px;
}
.note-list {
  background-color: orange;
}
</style>
